import React, { useState, useEffect } from 'react';

import { Typography, Grid, Button } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import playButton3 from '../assets/playAudio3.svg';
import pauseButton from '../assets/pauseAudio.svg';
import karenPullQuote from '../assets/audio/karenPullQuote.wav';
import orangeOrb from '../assets/orangeOrbPullQuote1.svg';
import orangeOrbM from '../assets/orangeOrbPullQuote1Mobile.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    marginTop: '6.25rem',
    position: 'relative',
    // overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      marginTop: '3.125rem'
    }
  },
  text: {
    width: '51%',
    textAlign: 'center',
    borderTop: '1px solid black',
    borderBottom: '1px solid black',
    [theme.breakpoints.down('sm')]: {
      width: '75%'
    }
  },
  pullQuote: {
    ...theme.extraFonts.pullQuote,
    paddingTop: '3.125rem',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body2
    }
  },
  quotationMark: {
    color: theme.palette.common.blue,
    fontSize: '60px',
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.body2
    }
  },
  name: {
    fontFamily: 'proximaNovaB',
    margin: '2.1rem 0',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0'
    }
  },
  audioButton: {
    marginBottom: '3.125rem',
    '&:hover': {
      transform: 'scale(1.1,1.1)'
    }
  },
  button1: {
    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none'
    }
  },
  orangeOrb: {
    position: 'absolute',
    top: '-170px',
    right: '0px',
    zIndex: -1
  }
}));

const karenPullQuoteAudio = new Audio(karenPullQuote);

const PullQuote1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const [isPlaying, setIsPlaying] = useState(false);

  const { ref, inView } = useInView({ threshold: 0.2 });
  const animation = useAnimation();

  useEffect(() => {
    if (inView) {
      animation.start({
        opacity: 1,
        transition: {
          type: 'spring',
          duration: 5
        }
      });
    }
    if (!inView) {
      animation.start({ opacity: 0 });
    }
  }, [inView, animation]);

  const audioClickHandler = (name) => {
    if (isPlaying) {
      karenPullQuoteAudio.pause();
      setIsPlaying(false);
    } else {
      karenPullQuoteAudio.play();
      setIsPlaying(true);
    }
  };

  return (
    <Grid container justifyContent="center" className={classes.wrapper}>
      <motion.img
        ref={ref}
        animate={animation}
        src={matchesSM ? orangeOrbM : orangeOrb}
        alt="orange gradient circle"
        className={classes.orangeOrb}
      />
      <Grid item className={classes.text}>
        <Typography className={classes.pullQuote}>
          <span className={classes.quotationMark}>“</span>In 1993, when I was first diagnosed, the
          climate in the African American community was not to speak about breast cancer...
        </Typography>
        <Typography variant="body2" className={classes.name}>
          Karen Eubanks Jackson
        </Typography>
        <Button
          disableRipple
          disableFocusRipple
          classes={{ root: classes.button1 }}
          onClick={() => {
            audioClickHandler();
          }}
        >
          <img
            src={isPlaying ? pauseButton : playButton3}
            alt="audio controller"
            className={classes.audioButton}
            style={{ height: '47px' }}
          />
        </Button>
      </Grid>
    </Grid>
  );
};

export default PullQuote1;
